import { AutogenModelServiceIncidentList, AutogenRowServiceIncidentList } from "./autogen/AutogenModelServiceIncidentList";

export class ModelServiceIncidentList extends AutogenModelServiceIncidentList<RowServiceIncidentList> {
	constructor() {
		super(RowServiceIncidentList);
	}
}

export class RowServiceIncidentList extends AutogenRowServiceIncidentList {
}